module.exports = __webpack_public_path__ + "static/pubconfkc19-1f7bb86c1d5523791584e6b19a8d26d6.jpg";